<template>
    <div v-if="notifi"></div>
</template>

<script>

    import Vue from 'vue'
    import VueNativeNotification from '@/vue-native-notification'
    import Store from '@/store/index'

    Vue.use(VueNativeNotification,{
        requestOnNotify: true
    })

    export default {

        name: 'Notificacion-Global',

        data(){
            return{
                una:0
            }
        },

        mounted(){
            

        },

        props:{
            
        },

        methods:{
            
            notify(i){

                const notification = {
        
                    title: i.titulo,
                    options: {
                        'body': i.contenido,
                        'icon': i.icono
                    },

                    events: {
                        onerror(){
                            console.log('Custom error event was called');
                        },
                        onclick(){
                            console.log('Custom click event was called');
                        },
                        onclose(){
                            console.log('Custom close event was called');
                        },
                        onshow(){
                            console.log('Custom show event was called');
                        }
                    }
                }
                
                this.$notification.show(notification.title, notification.options, notification.events)
                setTimeout(()=>{this.destruir()},200);
            },

            destruir(){
                Store.commit('set_notificacion_global',{'run':false,'titulo':'','contenido':'','icono':''})
            }
            
        },

        computed:{

            notifi(){
                var i = Store.state.notificacion_global
                if(i.run){ this.notify(i) }
                return i.run
            }

        },

        filters:{
        
        }

    }
</script>

<style scoped>

</style>